// Copyright 2025. WebPros International GmbH. All rights reserved.

import styled from 'styled-components';
import { COLORS } from 'admin/core/theme';

export const ErrorMessage = styled.div`
  font-size: 12px;
  padding: 0;
  color: ${COLORS.RED};
`;
